import { z } from "zod";

export const stringToJSONSchema = z.string().transform((str, ctx) => {
	try {
		return JSON.parse(str);
	} catch (e) {
		ctx.addIssue({ code: "custom", message: "Invalid JSON" });
		return z.NEVER;
	}
});

export enum LiveMessageType {
	TerminalStdout = "terminal::stdout",
	Arst = "arst",
}

export const liveMessageTypeSchema = z.nativeEnum(LiveMessageType);

export const terminalLiveMessageSchema = z.object({
	type: z.literal(LiveMessageType.TerminalStdout),
	/** Text content to write to the terminal */
	content: z.string(),
});

export type TerminalLiveMessage = z.infer<typeof terminalLiveMessageSchema>;

export const liveMessageSchema = z.discriminatedUnion("type", [
	terminalLiveMessageSchema,
]);

export type LiveMessage = z.infer<typeof liveMessageSchema>;
